<div class="sh-fixed-header-panel">
    <div class="sh-fixed-header-panel__head">
        <div class="sh-fixed-header-panel__head__title">{{ "plugins.record-tree.title" | translate }}</div>
    </div>
    <div class="sh-fixed-header-panel__content">
        <ng-container *ngIf="loading$ | async">{{ "ui.loading" | translate }}</ng-container>

        <ng-container *ngIf="recordTreeNodes$ | async as recordTreeNodes">
            <div *ngIf="recordTreeNodes.length > 0; else noRecordTree" class="sh-facet-list">
                <sh-tree-viewer
                    [nodes]="recordTreeNodes"
                    [hideRootNodes]="false"
                    [multiple]="false"
                    [loadingMsg]="'ui.loading' | translate"
                    [getChildrenFct]="getNodeNarrowerRecordTree"
                    [loadMoreMsg]="'ui.load-more' | translate"
                    (selectedNodes)="onSelectedNodes($event)"
                    (updatedNodes)="onUpdatedNodes($event)"
                ></sh-tree-viewer>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #noRecordTree>{{ "ui.loading-failed" }}</ng-template>
